import CityPageTemplate from "../city-template/CityPageTemplate";
import { puebloConfig } from "./data";

export default function PuebloPage() {
  return <CityPageTemplate config={puebloConfig} />;
}